export function handleCTACallback({ props, entity, entityType, ctaType, skuId, planId, isOpenedFromPDP, ribbonKey }) {
    // getUserAuthStatus will set the state based on the users sign in state, then let the cta show up based on the state.
    props.getUserAuthStatus().then(()=>{
        props.showCTAModal({
            entityId: entity.entityId,
            entityType,
            ctaType,
            skuId,
            planId,
            isOpenedFromPDP,
            ribbonKey
        });
    });
}
